import template from './record-custom-fields.pug';

export const RecordCustomFieldsComponent = {
  template,
  bindings: {
    record: '<',
    recordType: '@',
    state: '<?',
    onUpdate: '&?',
  },
  controller: class RecordCustomFieldsComponent {
    constructor(CustomField, $stateParams, $log, $async) {
      'ngInject';

      this.CustomField = CustomField;
      this.stateParams = $stateParams;
      this.$log = $log;
      this.loadCustomFields = $async(this.loadCustomFields.bind(this));
      this.addCustomField = $async(this.addCustomField.bind(this));
    }

    $onInit() {
      this.cfGroups = [];
      this.state = this.state || 'show';
      this.loadCustomFields();
    }

    isFormState(state) {
      return this.state == state;
    }

    toggleFormState() {
      this.state = this.state == 'show' ? 'edit' : 'show';
    }

    check() {
      this.stateParams.formDirty = this.temp !== JSON.stringify(this.record);
      this.record = angular.copy(this.record);
    }

    setCopy() {
      this.temp = JSON.stringify(this.record);
    }

    save(record, form) {
      this.stateParams.formDirty = false;
      if (form.$valid) {
        this.onUpdate({
          $event: { record }
        });
        this.toggleFormState();
      } else {
        this.AlertBox.addMessage('validation_messages.fill_required_fields', { type: 'warning' });
      }
    }

    async loadCustomFields() {
      try {
        const count = await this.CustomField.count({ module: this.recordType });
        if (!count) {
          return;
        }
        this.cfGroups = await this.CustomField.loadGroups({ module: this.recordType });
      } catch (e) {
        this.$log.error(e);
      }
    }

    async addCustomField() {
      try {
        let cfGroup = this.cfGroups[0];

        if (!cfGroup) {
          cfGroup = { generic_module: this.recordType };
        }

        await this.CustomField.createFieldModal(cfGroup);
        this.loadCustomFields();
      } catch (e) {
        this.$log.error(e);
      }
    }

  }
};
